import React from 'react';
import styles from './AdditionalInfoElement.module.scss';

export const AdditionalInfoElement = (additionalInfoElement: string) => (
    <div className={styles.additionalInfo} dangerouslySetInnerHTML={{ __html: additionalInfoElement }} />
);
